import * as React from 'react';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { useTheme } from '../../theming/useTheme';

const componentConfigurationKey = 'mobileTopBar';

interface MobileTopBarColorProps {
  backgroundColor: string;
}

export const MobileTopBarColor: React.FunctionComponent = () => {
  const { backgroundColor } = useTheme<MobileTopBarColorProps>(componentConfigurationKey);
  return (
    <ErrorBoundary>
      <Helmet>
        <meta name="theme-color" content={backgroundColor} />
      </Helmet>
    </ErrorBoundary>
  );
};
